import {parseString, genSVG} from "../glycan-interpreter/parser";
import generateTreeLayout from "../glycan-interpreter/treeGen";
import GenSVG from "../glycan-interpreter/genSVG";
import { useEffect, useState } from "react";

//creates an svg image from CASPER string
function AutoSVG({casperString, nodes, edges}) {

    const [svgNodes, setSVGNodes] = useState([]);
    const [svgEdges, setSVGEdges] = useState([])

    useEffect(() => {
        try{
            //decode the text
            let data = parseString(casperString);
            let [nodes,edges,arranged] = data; 
            // rearrange the nodes with automatic layout
            if (!arranged){
                let posMappings = generateTreeLayout(data);
                nodes = nodes.map(node => {
                    return {...node, x:posMappings.get(node.id).x, y:posMappings.get(node.id).y}; 
                })
            }
            setSVGNodes(nodes);
            setSVGEdges(edges);
        } catch (error)
        {
            setSVGNodes([]);
            setSVGEdges([]);
        }
    }, [casperString]);

    return (
        <div>
            <GenSVG offset={{x:40, y:20}} nodes={svgNodes} edges={svgEdges}/>
        </div>
    );
}

export default AutoSVG;